<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Period</label>
                  <a-range-picker
                    :placeholder="['Start Period', 'End Period']"
                    v-model="transactionDt"
                    format="MMMM-YYYY"
                    allowClear
                    :disabled="disabled.transactionDt"
                  />
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :tabbedTransactional="true"
        :isTransactional="true"
        :loading="loading"
        title="Expenditure Plan"
        :createLink="getLinkCreate()"
        :manifestLink="getManifest()"
        editLink="lapKegPdEdit"
        :draftEditLink="getEditDraft()"
        dataListTitle="List"
        dataDraftTitle="Draft"
        :draftDeleteLink="true"
        :dataList="searching.list"
        :draftList="searching.draft"
        :allowcancel="true"
      >
        <template slot="row_extra" slot-scope="item">
          <a-tag
            :color="item.item.status_hrd.includes('Has Been') ? 'green' : 'orange'"
            class="margin-remove"
          >{{ item.item.status_hrd }}</a-tag>
        </template>
      </DataList>
    </a-col>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import Status from "@/components/Status.vue";
import GlobalMethod from "@/mixins/GlobalMethod";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "listLapKegPd",
  components: { Status },
  mixins: [GlobalMethod, CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: {
        list: [],
        draft: []
      },
      search: "",
      transactionDt: [],
      activetab: "list",
      disabled: {
        transactionDt: false,
        status: false
      }
    };
  },
  mounted() {
    this.fetchData();
    Event.$on("emitDeleteLink", this.deleteDraft);
    Event.$on("callbackTab", this.clickTabed);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("emitDeleteLink", this.deleteDraft);
    Event.$off("callbackTab", this.clickTabed);
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getDefaultDateFormat"]),
    searching: function () {
      const self = this;
      let output = {
        list: this.dataList.list,
        draft: this.dataList.draft,
      };
      if (this.activetab == "list") {
        if (this.search) {
          output.list = output.list.filter(
            (obj) =>
              obj.Qsearch.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        }

        if (self.transactionDt.length > 0 && self.transactionDt[0]!=null  && self.transactionDt[1] != null) {
          let startDt = moment(self.transactionDt[0]).format(
            'YYYY-M'
          );
          let endDt = moment(self.transactionDt[1]).format(
            'YYYY-M'
          );
          output.list = output.list.filter(
            (obj) =>
              moment(obj.period).format('YYYY-M') >=
              startDt &&
              moment(obj.period).format('YYYY-M') <= endDt
          );
        }
      } else {
        if (this.search) {
          output.draft = output.draft.filter(
            (obj) =>
              obj.Qsearch.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        }
      }

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "Rencana_belanja",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataList.list = [];
          response.data.list.forEach((data) => {
            this.dataList.list.push({
              title: data.no_rencana_belanja,
              unread: false,
              subdesc: [
                moment(data.tgl_buat,'DD-MM-YYYY').format(
                      this.getDefaultDateFormat
                    ) + " | " + data.pembuat,
                data.periode_bulan + '-' + data.periode_tahun,
                this.formatRupiah(data.total_rencana).replace(',00', '')
              ],
              period: moment(data.periode_bulan+"-"+data.periode_tahun,'MMM-YYYY'),
              Qsearch: data.no_rencana_belanja+moment(data.tgl_buat,'DD-MM-YYYY').format(
                      this.getDefaultDateFormat
                    ) + data.pembuat + data.periode_bulan + '-' + data.periode_tahun+this.formatRupiah(data.total_rencana).replace(',00', ''),
              id: data.rencana_belanja_id,
            });
          });

          response.data.draft.forEach((data) => {
            this.dataList.draft.push({
              title: moment(data.tgl_buat,'DD-MM-YYYY').format(
                      this.getDefaultDateFormat
                    ) + " | " + data.pembuat,
              subdesc: [
                data.periode_bulan + '-' + data.periode_tahun,
                this.formatRupiah(data.total_rencana).replace(',00', '')
              ],
              period: moment(data.periode_bulan+"-"+data.periode_tahun,'MMM-YYYY'),
              id: data.rencana_belanja_id,
              loading_delete: false,
              Qsearch : moment(data.tgl_buat,'DD-MM-YYYY').format(
                      this.getDefaultDateFormat
                    ) + data.pembuat + data.periode_bulan + '-' + data.periode_tahun+this.formatRupiah(data.total_rencana).replace(',00', '')
              });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "pdlk",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.fetchData();
          this.searching;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    clickTabed(val) {
      this.activetab = val;
      if (val == "draft") {
        this.transactionDt = [null,null];
        this.status = undefined;
        this.disabled.transactionDt = true;
        this.disabled.status = true;
      } else {
        this.disabled.transactionDt = false;
        this.disabled.status = false;
      }
    },
    deleteDraft(val) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let indx = _.findIndex(that.dataList.draft, (e) => { return e.id == val.id })
          that.dataList.draft[indx].loading_delete = true;
          that.asyncAxiosDelete(
            "Rencana_belanja/draft",
            "application/json",
            that.getAuth,
            {
              rencana_belanja_id: val.id,
            }
          )
            .then(() => {
              that.dataList.draft = _.filter(that.dataList.draft, (e) => e.id != val.id)
            })
            .catch((err) => {
              console.log(err)
              that.dataList.draft[indx].loading_delete = false;
            });
        },
        onCancel() { },
      })
    },
    getLinkCreate(){
      return this.$route.name=='expenditurePlanAL' ? 'expenditurePlanCreateAL' : 'expenditurePlanCreatePimpro';
    },
    getEditDraft(){
      return this.$route.name=='expenditurePlanAL' ? 'expenditurePlanEditAL' : 'expenditurePlanEditPimpro';
    },
    getManifest(){
      return this.$route.name=='expenditurePlanAL' ? 'expenditurePlanManifestAL' : 'expenditurePlanManifestPimpro';
    }
  },
};
</script>

<style lang="less">
.ant-list-item {
  &-action {
    background-color: whitesmoke;
    padding: 5px 0;
  }
}
</style>
